import React, { useMemo } from 'react';
import { useGlobalSvgMask } from '../GlobalSvgMasks';

export const Ring = ({
  cx,
  cy,
  rSpacer = 7,
  rOuter = 5,
  rInner = 3,
  inverse = false,
}) => {
  const maskId = useMemo(
    () => `ring-mask-${rSpacer}-${rOuter}-${rInner}`,
    [rSpacer, rOuter, rInner]
  );

  const [fill1, fill2] = useMemo(
    () => (inverse ? ['white', 'black'] : ['black', 'white']),
    [inverse]
  );

  useGlobalSvgMask(
    maskId,
    <g>
      <circle cx={0} cy={0} r={rSpacer} fill={fill1} />
      <circle cx={0} cy={0} r={rOuter} fill={fill2} />
      <circle cx={0} cy={0} r={rInner} fill={fill1} />
    </g>
  );

  return (
    <g className="chart-ring" transform={`translate(${cx},${cy})`}>
      <circle
        mask={`url(#${maskId})`}
        className="palette-fill outer-ring"
        cx={0}
        cy={0}
        r={rOuter}
      />
    </g>
  );
};

export default Ring;
